import { useEffect, useState } from 'react';

export default function TerritorySelectionModal({ isOpen, onClose, handleSave, territoryList }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedTerritory, setSelectedTerritory] = useState();
  let [showTreeNode, setShowTreeNode] = useState(true);

  const territories = [
    {
      id: 1,
      name: 'Digylax Private Limited',
      children: [
        {
          id: 2,
          name: 'Chennai',
          children: [
            { id: 3, name: 'Denmark', children: [] }
          ]
        },
        { id: 4, name: 'Coimbatore', children: [] },
        { id: 5, name: 'Salem', children: [] },
        { id: 6, name: 'Trichy', children: [] },
        { id: 7, name: 'Denmark', children: [] }
      ]
    }
  ];

  // const handleSave = () => {
  //   onSave && onSave(selectedTerritory);
  //   onClose && onClose();
  // };
  // useEffect(() => {
  //   onSave && onSave(selectedTerritory);
  //   onClose && onClose();
  //   console.log('***')
  //   // onSave(selectedTerritory);
  //   // onClose();
  // }, [selectedTerritory])

  const handleSelect = (id) => {
    const selectedTerritory = territoryList.find(obj => obj._id === id);
    setSelectedTerritory(selectedTerritory)
    handleSave(selectedTerritory);
  }

  if (!isOpen) return null;

  // Filter territories based on search query (simplified implementation)
  const filterTerritories = (items, query) => {
    if (!query) return items;

    // This is a simple implementation. In a real app, you'd want more sophisticated filtering
    return items.filter(item =>
      item.name.toLowerCase().includes(query.toLowerCase()) ||
      (item.children && item.children.some(child =>
        child.name.toLowerCase().includes(query.toLowerCase()))));
  };

  // const renderTerritoryTree = (items, level = 0) => {
  //   return items.map(item => (
  //     <div key={item.id}>
  //       <div className="d-flex align-items-center" style={{ marginLeft: `${level * 20}px` }}>
  //         {level > 0 && (
  //           <div className="position-relative me-2" style={{ width: '20px', height: '20px' }}>
  //             <div className="position-absolute" style={{
  //               borderLeft: '1px dashed #ccc',
  //               height: '100%',
  //               left: '50%',
  //               top: '-10px'
  //             }}></div>
  //             <div className="position-absolute" style={{
  //               borderTop: '1px dashed #ccc',
  //               width: '50%',
  //               top: '50%',
  //               left: '50%'
  //             }}></div>
  //           </div>
  //         )}
  //         <div className="form-check mb-2">
  //           <input
  //             className="form-check-input"
  //             type="radio"
  //             name="territory"
  //             id={`territory-${item.id}`}
  //             checked={selectedTerritory === item.name}
  //             onChange={() => setSelectedTerritory(item.name)}
  //           />
  //           <label className="form-check-label" htmlFor={`territory-${item.id}`}>
  //             {item.name}
  //           </label>
  //         </div>
  //       </div>
  //       {item.children && renderTerritoryTree(item.children, level + 1)}
  //     </div>
  //   ));
  // };

  // const TreeNode = ({ node, index }) => {
  //   // console.log('node:', node)
  //   return (
  //     <>
  //       <ul className="nested-list">
  //         <li className="nested-item" style={{ cursor: "pointer" }}>
  //           <div className="d-inline-block ps-4 role-name-box">
  //             <span className="fs-14" onClick={() => handleSelect(index)}>{node?.territory_name}</span>
  //             {/* <span className="label action-btns border-0">
  //               <span className="act-btn add-btn rounded-pill cursor-pointer" role="button" title="Create Subordinate Role">
  //                 <i className="fa-solid fa-user"></i>
  //               </span>
  //               <span className="act-btn add-btn rounded-pill cursor-pointer" role="button" title="Create Subordinate Role">
  //                 <i className="fas fa-plus"></i>
  //               </span>
  //               <span className="act-btn edit-btn rounded-pill cursor-pointer" role="button" title="Edit">
  //                 <i className="fas fa-pencil"></i>
  //               </span>
  //               <span className="act-btn delete-btn rounded-pill cursor-pointer" role="button" title="Delete">
  //                 <i className="fas fa-trash"></i>
  //               </span>
  //             </span> */}
  //           </div>
  //         </li>
  //       </ul>
  //     </>
  //   )
  // }

  const groupByParentId = (territories) => {
    const obj = {};
    territories?.forEach(territory => {
      const key = territory.parent_territory?.id || "null";
      if (!obj[key]) obj[key] = [];
      obj[key].push(territory);
    });
    return obj;
  };

  let result = groupByParentId(territoryList);

  const TreeNode = (parentId, isInitial = false) => {
    let data = result[parentId] || [];
    return (
      <ul className={isInitial ? "tree mt-3" : "nested-list"}>
        {data?.map((child) => (
          <li className={isInitial ? "parent" : "nested-item"} key={child._id}>

            <div className="d-inline-block ps-4 role-name-box cursor-pointer" onClick={() => handleSelect(child._id)}>
              {child.territory_name}
            </div>
            {result[child._id] && (
              <details open={showTreeNode} className="details">
                <summary></summary>
                {TreeNode(child._id)}
              </details>
            )}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
      <div className="bg-white rounded shadow-lg p-4" style={{ width: '90%', maxWidth: '600px' }}>
        <h5 className="mb-4">Choose Parent Territory</h5>

        <div className="d-flex justify-content-between mb-4">
          <div className="position-relative" style={{ width: "70%" }}>
            <i className="bi bi-search position-absolute text-secondary" style={{ top: '12px', left: '12px', fontSize: '18px' }} />
            <input
              type="text"
              className="form-control ps-4"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <button className="btn btn-link">Collapse All</button>
        </div>

        {/* new parent ui::start */}
        <div>{TreeNode("null", true)}</div>
        {/* new parent ui::end */}
        {/* parent ui::start */}
        <div className='d-none'>
          <ul className="tree mt-3">
            <li className="parent">
              <div className="d-inline-block ps-4 role-name-box cursor-pointer" onClick={() => handleSelect(0)}>{territoryList?.[0]?.territory_name}
                {/* <span className="label action-btns border-0">
                  <span className="act-btn add-btn rounded-pill cursor-pointer" role="button" title="Create Subordinate Role">
                    <i className="fas fa-plus"></i>
                  </span>
                  <span className="act-btn edit-btn rounded-pill cursor-pointer" role="button" title="Edit">
                    <i className="fas fa-pencil"></i>
                  </span>
                </span> */}

              </div>
              <details open={showTreeNode} className="details">
                <summary></summary>
                {territoryList?.length > 0 && territoryList?.map((node, index) => index !== 0 && (
                  <TreeNode key={node._id} node={node} index={index} />
                ))}
              </details>
            </li>
          </ul>
        </div>
        {/* parent ui::end */}

        {/* <div className="mb-4" style={{ maxHeight: '300px', overflowY: 'auto' }}>
          {renderTerritoryTree(filterTerritories(territories, searchQuery))}
        </div> */}

        <div className="mb-3 mt-4 pt-2 border-top">
          <h6>Territory Rules</h6>
          <p className="text-secondary small">To automatically assign territories to records, please fill out the rule criteria</p>
        </div>

        <div className="d-flex justify-content-end mt-4">
          <button className="btn btn-outline-secondary me-2" onClick={onClose}>Cancel</button>
          {/* <button className="btn btn-primary" onClick={handleSave}>Save</button> */}
          {/* <button className="btn btn-primary" style={{ backgroundColor: '#007bff', borderColor: '#007bff', color: '#ffffff' }} onClick={handleSave}>Save</button> */}
        </div>
      </div>
    </div>
  );
}
